<template>
  <div>
    <v-alert :type="alertType" v-model="alertActive" dismissible outline>
      {{ alertMessage }}
    </v-alert>

    <v-flex xs12 sm6 offset-sm3>
      <v-card max-width="600px">
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-container class="primary" fill-height>
            <v-layout fill-height>
              <v-flex xs12 align-end flexbox>
                <span class="headline white--text">
                  {{ $t('change_password') }}
                </span>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container>
            <v-layout row wrap>
              <v-flex xs12>
                <v-flex xs12>
                  <v-text-field
                    name="pwd"
                    :label="$t('old_password')"
                    id="pwd-old"
                    type="password"
                    :rules="rules_old"
                    v-model="old_pwd"
                    :append-icon="show2 ? 'visibility' : 'visibility_off'"
                    :type="show2 ? 'text' : 'password'"
                    :hint="$t('at_least_8_characters')"
                    counter
                    @click:append="show2 = !show2"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="new-pwd"
                    id="pwd-new"
                    v-model="new_pwd"
                    :append-icon="show ? 'visibility' : 'visibility_off'"
                    :rules="rules"
                    :type="show ? 'text' : 'password'"
                    :label="$t('new_password')"
                    :hint="$t('at_least_8_characters')"
                    counter
                    @click:append="show = !show"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field
                    name="ret-pwd"
                    :label="$t('retype_password')"
                    id="pwd-old"
                    type="password"
                    v-model="retype_pwd"
                    :append-icon="show1 ? 'visibility' : 'visibility_off'"
                    :rules="retype_rules"
                    :type="show1 ? 'text' : 'password'"
                    :hint="$t('at_least_8_characters')"
                    counter
                    @click:append="show1 = !show1"
                  ></v-text-field>
                </v-flex>
              </v-flex>
            </v-layout>
          </v-container>
          <v-card-actions>
            <v-btn flat to="/ecrmregistration">{{ $t('back') }}</v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!valid" color="primary" @click="changePassword">
              {{ $t('proceed') }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </div>
</template>

<script>
export default {
  data() {
    return {
      alertActive: false,
      alertType: 'success',
      alertMessage: '',
      valid: false,
      old_pwd: '',
      new_pwd: '',
      retype_pwd: '',
      show: false,
      show1: false,
      show2: false,
      rules_old: [v => !!v || this.$t('passwd_is_required')],
      rules: [
        v => !!v || this.$t('passwd_is_required'),
        v => {
          if (v.length >= 8) {
            const hasUpperCase = /[A-Z]/.test(v)
            const hasLowerCase = /[a-z]/.test(v)
            const hasNumbers = /\d/.test(v)
            const hasNonalphas = /\W/.test(v)
            if (hasUpperCase + hasLowerCase + hasNumbers + hasNonalphas < 3) {
              return this.$t('passwd_must_contains')
            } else {
              return true
            }
          } else {
            return this.$t('passwd_is_short')
          }
        }
      ],
      retype_rules: [
        v => !!v || this.$t('passwd_is_required'),
        v => v === this.new_pwd || this.$t('password_do_not_match')
      ]
    }
  },
  methods: {
    async changePassword() {
      if (!this.$refs.form.validate()) {
        return
      }
      this.$root.$loader(true)
      try {
        let res = await this.axios.get(
          this.$providerURL + '/Api/Access/ChangePassword',
          { params: { oldPassword: this.old_pwd, newPassword: this.new_pwd } }
        )
        this.showAlert(this.$t('pwd_changed'), 'success')
        this.$refs.form.reset()
      } catch (error) {
        this.$root.$gerror(error.response.data)
      } finally {
        this.$root.$loader(false)
      }
    },
    showAlert(message, type) {
      this.alertMessage = message
      this.alertType = type
      this.alertActive = true
      setTimeout(() => (this.alertActive = false), 10000)
    }
  }
}
</script>
